module.exports = __webpack_public_path__ + "static/media/NUS_ISS.afa8d332.png";